import GreenHouse from '@/api/green-house'

export default {
  namespaced: true,
  state: {
    autoPost: false,
    autoApplicants: false,
    email: '',
    apiKey: '',
    webhookUrl: '',
    authUsername: '',
    authPassword: '',
    authRegPassword: '',
    companyId: null,
    type: '',
    emailError: null,
    apiKeyError: null,
    loading: false,
    disconnectLoading: false,
    greenHouseConnected: false,
    feedbackMessage: null,
    error: false,
    gpLoading: false
  },
  mutations: {
    resetGreenhouseForm (state) {
      state.autoPost = false
      state.autoApplicants = false
      state.email = ''
      state.apiKey = ''
      state.webhookUrl = ''
      state.authUsername = ''
      state.authPassword = ''
      state.type = ''
      state.authRegPassword = ''
    },
    setAutoPost (state, autoPost) {
      state.autoPost = autoPost
    },
    setAutoApplicants (state, autoApplicants) {
      state.autoApplicants = autoApplicants
    },
    setEmail (state, email) {
      if (email.length > 0) {
        state.emailError = null
      }
      state.email = email
    },
    setApiKey (state, apiKey) {
      if (apiKey.length > 0) {
        state.apiKeyError = null
      }
      state.apiKey = apiKey
    },
    setWebhookUrl (state, webhookUrl) {
      state.webhookUrl = webhookUrl
    },
    setAuthUsername (state, authUsername) {
      state.authUsername = authUsername
    },
    setAuthPassword (state, authPassword) {
      state.authPassword = authPassword
    },
    setType (state, type) {
      state.type = type
    },
    setEmailError (state, emailError) {
      state.emailError = emailError
    },
    setApiKeyError (state, apiKeyError) {
      state.apiKeyError = apiKeyError
    },
    setLoading (state, loading) {
      state.loading = loading
    },
    setGreenHouseConnected (state, greenHouseConnected) {
      state.greenHouseConnected = greenHouseConnected
    },
    setError (state, error) {
      state.error = error
    },
    setFeedbackMessage (state, feedbackMessage) {
      state.feedbackMessage = feedbackMessage
    },
    setAuthRegPassword (state, authRegPassword) {
      state.authRegPassword = authRegPassword
    },
    setGpLoading (state, gpLoading) {
      state.gpLoading = gpLoading
    },
    setCompanyId (state, companyId) {
      state.companyId = companyId
    },
    setDisconnectLoading (state, disconnectLoading) {
      state.disconnectLoading = disconnectLoading
    }
  },
  actions: {
    async attachGreenHouse ({commit, state}) {
      try {
        commit('setLoading', true)
        const {autoPost, autoApplicants, email, apiKey, type, companyId} = state
        const data = {
          receiveJobPost: autoPost,
          sendApplicants: autoApplicants,
          ghServiceEmail: email,
          ghApiKey: apiKey,
          defaultJobTypeId: type,
          generateNewKey: false
        }
        const res = await GreenHouse.attachGreenHouse(data, companyId)
        const {webHookUrl} = await GreenHouse.checkGreenHouse(companyId)
        commit('setLoading', false)
        commit('setAuthUsername', res.username)
        commit('setAuthPassword', res.password)
        commit('setWebhookUrl', webHookUrl)
        commit('setGreenHouseConnected', true)
        commit('setFeedbackMessage', 'GREENHOUSE ATS CONNECTED')
      } catch (e) {
        commit('setLoading', false)
        commit('setError', true)
        commit('setFeedbackMessage', e.message)
      }
    },
    async disconnectGreenHouse ({commit, state}, {toggle}) {
      try {
        const {companyId} = state
        commit('setDisconnectLoading', true)
        await GreenHouse.disconnectGreenHouse(companyId)
        commit('resetGreenhouseForm')
        commit('setGreenHouseConnected', false)
        throw new Error('GREENHOUSE ATS DISCONNECTED')
      } catch (e) {
        commit('setDisconnectLoading', false)
        toggle()
        commit('setError', true)
        commit('setFeedbackMessage', e.message)
      }
    },
    async checkGreenHouseStatus ({commit, state}) {
      try {
        const {companyId} = state
        commit('setLoading', true)
        const res = await GreenHouse.checkGreenHouse(companyId)
        const {webHookUrl, username, ghApiKey, ghServiceEmail, defaultJobTypeId, sendApplicants, receiveJobPost} = res
        commit('setApiKey', ghApiKey)
        commit('setEmail', ghServiceEmail)
        commit('setType', defaultJobTypeId)
        commit('setAutoApplicants', sendApplicants)
        commit('setAutoPost', receiveJobPost)
        commit('setAuthUsername', username)
        commit('setWebhookUrl', webHookUrl)
        commit('setGreenHouseConnected', true)
        commit('setLoading', false)
      } catch (e) {
        commit('setGreenHouseConnected', false)
        commit('setLoading', false)
      }
    },
    async generatePassword ({commit, state}) {
      try {
        const {companyId} = state
        commit('setGpLoading', true)
        const res = await GreenHouse.generatePassword(companyId)
        commit('setGpLoading', false)
        commit('setAuthRegPassword', res.password)
      } catch (e) {
        commit('setGpLoading', false)
        commit('setError', true)
        commit('setFeedbackMessage', e.message)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/green-house.js